import React from "react";
import styles from "./index.module.scss";
import { Avatar } from "@mui/material";
import { Button } from "../../../common/components/Button";
import { DashedBorderBox } from "../../../common/components/DashedBorderBox";
import defaultProfileIcon from "../../../assets/images/default-profile.svg";
import cross_Bg from "../../../assets/images/CrossNew.svg";
import SessionOverlay from "../../../components/SeatApprovalFlow/SessionOverlay";
import { ApprovalStatus, textConstant } from "../../../constants/textConstants";
import { SessionsGridProps } from "../../../types/seatApproval";
import uniarrow from "../../../assets/images/swap-arrow-1.svg";
import swaparrow from "../../../assets/images/swap-arrow-2.svg";
import profile from "../../../assets/images/profile-bg.webp";
import { handleSessionGridBlessAction } from "../../../utils/seekerApproval";
import SwapActionCard from "../SwapActionCard";
import BuildingOffice from "../../../assets/images/org.svg";
import { formatSingleDigit } from "../../../utils/commonFunctions";
import { colorizeMahatriaInfinitheism } from "../ColorizeMahatriaInfinitheism";

export const SessionsGrid: React.FC<SessionsGridProps> = ({
  sessions,
  dragOverSessionId,
  selectedSession,
  showOverlay,
  sessionId,
  approvedUsers,
  isLoading,
  programId,
  totalRecords,
  onDragOver,
  onDragLeave,
  setSelectedSession,
  onDrop,
  onSessionClick,
  onRemoveFromSession,
  onBless,
  onCloseOverlay,
  handleBlessed,
  selectedSwapSeeker,
  fetchApprovedUsersForSession,
  setShowOverlay,
  setExcludedUserId,
  setCustomTitle,
  setIsCardClicked,
  sessionpaginationProps,
  handleSessionPageChange,
  handleSessionPageSizeChange,
  setSessionSearchText,
  selectedFilter,
  setSelectedFilter,
  overlayLoader = false, // Default value for overlayLoader
  draggedUser,
}) => {
  const handleOpenSessionOverlay = async (
    userId: number,
    selectedSession?: unknown,
  ) => {
    // Use fetchApprovedUsersForSession to get all users with kpiCategory and kpiFilter as "all"
    setShowOverlay(true); // Open the overlay
    setCustomTitle &&
      setCustomTitle(`Select seeker to swap from ${selectedSession?.name}`);
    setIsCardClicked(true); // Set card clicked state to true
    setExcludedUserId(userId);
    setSelectedSession &&
      setSelectedSession({
        kpiCategory: "allocated",
        kpiFilter: `program_${selectedSession.value || selectedSession.id}`,
        SwapRequests: selectedFilter?.wantsSwap || "",
      });
    fetchApprovedUsersForSession({
      kpiCategory: "allocated",
      kpiFilter: `program_${selectedSession.value || selectedSession.id}`,
      SwapRequests: selectedFilter?.wantsSwap || "",
    });
  };

  const handleDragOver = (e: React.DragEvent, sessionId: number | string) => {
    if (e.dataTransfer.types.includes("application/json")) {
     
      onDragOver(e, sessionId);
    }
  };

  const handleDrop = (e: React.DragEvent, sessionId: string | number) => {
  if (e.dataTransfer.types.includes("application/json")) {
    const userData = e.dataTransfer.getData("application/json");
    const draggedUser = JSON.parse(userData);

    onDrop({ ...e, draggedUser }, sessionId);
  } else {
   
    e.stopPropagation(); // block images/icons/files
  }
};

  return (
    <div className={styles.sessionsGrid}>
      {sessions.map((session) => (
        <div
          key={session.id}
          className={`${styles.sessionCard} 
            ${dragOverSessionId === session.id ? styles.dragOver : ""}
            ${session.assignedUsers.length > 0 ? styles.hasUser : ""}`}
          onDragOver={(e) => handleDragOver(e, session.id)}
          onDragLeave={onDragLeave}
          onDrop={(e) => handleDrop(e, session.id)}
          onClick={() => onSessionClick(session)}
        >
          <div className={styles.sessionUsers}>
            {session?.assignedUsers?.length > 0 ? (
              session?.assignedUsers?.map((user) =>
                user?.approvalStatus === ApprovalStatus?.PENDING ||
                user?.approvalStatus === ApprovalStatus?.ON_HOLD ||
                user?.approvalStatus === ApprovalStatus?.REJECTED ||
                session?.name == "Hold" ||
                session?.name == "YTD" ? (
                  <div
                    key={user.id}
                    className={styles.assignedUser}
                    onClick={(e) => e.stopPropagation()}
                  >
                    <img
                      src={cross_Bg}
                      alt="cross"
                      className={styles.crossBg}
                      onClick={(e) => {
                        e.stopPropagation();
                        onRemoveFromSession(user, session.id);
                      }}
                    />
                    <div className={styles.userInfo}>
                      <Avatar
                        alt="User Avatar"
                        src={user.profileImage || defaultProfileIcon}
                        sx={{
                          width: 60,
                          height: 60,
                          border: "1px solid #00000014",
                        }}
                        data-testid="user-avatar"
                      />
                      <span className={styles.fullnameStyles}>
                        {session.name !== "Hold" && session.name !== "YTD" ? (
                          <span>
                            bless{" "}
                            <span
                              className={styles.fullnameEllipsis}
                              title={user.fullName}
                            >
                              {user.fullName}
                            </span>{" "}
                            with {colorizeMahatriaInfinitheism(session.name)}
                          </span>
                        ) : (
                          <span>
                            Place {user.fullName} on{" "}
                            {session.name === "Hold" ? "hold" : session.name}
                          </span>
                        )}
                      </span>
                    </div>

                    <div className={styles.buttonContainerbless}>
                      <Button
                        buttonClassName={styles.confirmButton}
                        buttonTextClassName={styles.cancelText}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleSessionGridBlessAction({
                            user,
                            session,
                            selectedSwapSeeker,
                            handleBlessed,
                            onBless,
                          });
                        }}
                      >
                        {session.name !== "Hold"
                          ? session.name !== "YTD"
                            ? "bless"
                            : "YTD"
                          : "hold"}
                      </Button>
                    </div>
                  </div>
                ) : (
                  <div
                    key={user?.id}
                    className={styles.assignedUser}
                    onClick={(e) => e.stopPropagation()}
                  >
                    <img
                      src={cross_Bg}
                      alt="cross"
                      className={styles.crossBgnew}
                      onClick={(e) => {
                        e.stopPropagation();
                        onRemoveFromSession(user, session.id);
                      }}
                    />

                    <div
                      className={styles.FlippedCard}
                      onClick={(e) => {
                        e.stopPropagation();
                      }}
                    >
                      <SwapActionCard
                        user={user}
                        selectedSwapSeeker={selectedSwapSeeker}
                        selectedPref={session}
                        handleBlessAction={(e) => {
                          e.stopPropagation();
                          handleSessionGridBlessAction({
                            user,
                            session,
                            selectedSwapSeeker,
                            handleBlessed,
                            onBless,
                          });
                        }}
                        handleOpenSessionOverlay={(userId, selectedPref) => {
                          handleOpenSessionOverlay(userId, selectedPref);
                        }}
                        _isFlipped={true}
                        isFromSessionsGrid={true}
                      />
                    </div>
                  </div>
                ),
              )
            ) : (
              <DashedBorderBox isDragOver={dragOverSessionId === session?.id}>
                <div
                  className={`${styles.sessionHeader} ${dragOverSessionId === session?.id ? styles.dragOver : ""}`}
                >
                  {session?.assignedUsers.length > 0 ||
                  (draggedUser?.approvalStatus === ApprovalStatus?.ON_HOLD &&
                    session?.name === ApprovalStatus?.YTD) ||
                  (draggedUser?.approvalStatus === ApprovalStatus?.REJECTED &&
                    session?.name === ApprovalStatus?.HOLD) ||
                  (draggedUser?.approvalStatus === ApprovalStatus?.REJECTED &&
                    session?.name === ApprovalStatus?.YTD) ||
                  draggedUser?.approvalStatus === ApprovalStatus?.CANCELLED ||
                  draggedUser?.allocatedProgram?.name === session?.name ||
                  (session?.name === ApprovalStatus?.YTD &&
                    draggedUser?.approvalStatus === ApprovalStatus.APPROVED) ? (
                    <h3 className={styles.sessionNameGrey}>
                      {colorizeMahatriaInfinitheism(session.name)}{" "}
                      {textConstant?.DISABLEQUEUE}
                    </h3>
                  ) : (
                    <h3 className={styles.sessionName}>
                      {colorizeMahatriaInfinitheism(session.name)}{" "}
                    </h3>
                  )}
                </div>
                <div className={styles.sessionInfo}>
                  <div className={styles.organization}>
                    <div className={styles.sessionCount}>
                      {session.name === "Hold" || session.name === "YTD" ? (
                        <span className={styles.totalSeekers}>
                          {session.totalSeekers}
                        </span>
                      ) : (
                        <p>
                          {session.allocatedCount} /{" "}
                          <span className={styles.totalSeekers}>
                            {session.totalSeekers}
                          </span>
                        </p>
                      )}
                    </div>

                    {session.organisationUserCount > 0 && (
                      <>
                        <span className={styles.verticalLine} />
                        <img src={BuildingOffice} alt="Building Office" />
                        <span>
                          {" "}
                          {formatSingleDigit(session.organisationUserCount)}
                        </span>
                      </>
                    )}
                  </div>
                  {session.name !== "Hold" && session.name !== "YTD" && (
                    <div className={styles.progressBarContainer}>
                      <div
                        className={styles.progressBar}
                        style={{
                          width:
                            session.totalSeekers > 0
                              ? `${(session.allocatedCount / session.totalSeekers) * 100}%`
                              : "0%",
                        }}
                      />
                    </div>
                  )}
                </div>
              </DashedBorderBox>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};
